import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import ESPSubscibersGrid from './ESPSubscibersGrid'
import Modal from "react-modal";
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from "../../assets/ic_close_wh.svg";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import api from "../../utils/api";
import { toast } from "react-toastify";
import Spinner from "../../common/Spinner/Spinner";



const ReactTableFixedColumns = withFixedColumns(ReactTable);


const ESPSubscribersInterface = () => {

    const gridRef = useRef()
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  const [data, setData] = useState()
  const [pages, setPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
	const [count, setCount] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setcurrentPage] = useState(0);
    const [tableInstance, setTableInstance] = useState(null);
	const [pageSizeOptions, setpageSizeOptions] = useState([
        {
            value: "10",
            label: "10 Rows",
        },
        {
            value: "20",
            label: "20 Rows",
        },
        {
            value: "30",
            label: "30 Rows",
        },
        {
            value: "50",
            label: "50 Rows",
        },
        {
            value: "75",
            label: "75 Rows",
        },
        {
            value: "100",
            label: "100 Rows",
        },
    ]);
    const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
        value: "10",
        label: "10",
    });

    const [oppourtunitiesModal, setOppourtunitiesModal] = useState(false)
    const [oppAvailedData, setOppAvailedData] = useState([])

    const [resourceAvailedModal, setResourcesAvailedModal] = useState(false)
    const [resourceAvailedData, setResourcesAvailedData] = useState([])

    const openOppourtunitiesAvailedModalisTrue = () => {
        setOppourtunitiesModal(true)
    }

    const openOppourtunitiesAvailedModalisFalse = () => {
        setOppourtunitiesModal(false)
        setOppAvailedData([])
    }

    const openResourcesAvailedModalisTrue = () => {
        setResourcesAvailedModal(true)
    }

    const openResourcesAvailedModalisFalse = () => {
        setResourcesAvailedModal(false)
        setResourcesAvailedData([])
    }

    const oppourtunitiesAvailedCountClick = (data) => {
        console.log("GetData", data)
        api.getPrimeMarketLinkageList(data)
        .then(({data}) => {
            console.log("USER MARKET LIST", data)
            setOppAvailedData(data.services)
        })
        openOppourtunitiesAvailedModalisTrue()
        // setOppAvailedData(data)
    }

    const resourceAvailedCountClick = (data) => {
        console.log("User Id", data)
        api.getPrimeServiceList(data)
        .then(({data}) => {
            console.log("UserData", data)
            setResourcesAvailedData(data.services)
        })
        openResourcesAvailedModalisTrue()
        // setResourcesAvailedData(data)
    }

    useEffect(() => {
		getGridData(tableInstance, true)
	}, [selectedPageSizeOption])


    const getGridData = async(instance, flag= false) => {
		if (!instance) return;
        if (!tableInstance) setTableInstance(instance);

		try{
			const { page } = instance.state ?? { page: 0 };
            let icurrentPage = page;
            if (!flag && isNaN(icurrentPage)) return;
            const pageSize = selectedPageSizeOption.value;

            if (flag || isNaN(icurrentPage)) {
                icurrentPage = 0;
            }

			let filterParameters = {
                page: icurrentPage + 1,
                page_size: pageSize,
                // pagination: true,
                // SP_email: 'archana.sapre@mailinator.com'
            };

			// if(resouceInstanceId){
			// 	filterParameters.nResourceInstanceId = resouceInstanceId
			// }

			setIsLoading(true);

			const {tempClosedServices} = api.getPrimeSubscriberList(filterParameters)
			.then(({data}) => {
				setIsLoading(false);
                if (data) {
                    console.log("Data", data)
                    const { results, count } = data;
                    setcurrentPage(icurrentPage);
                    const totalPages = (count - 1) / pageSize + 1;
                    setCount(count);
                    setPages(Math.floor(totalPages));
                    setPageSize(pageSize);
                    setData(results);
                }
				else {
                    toast("Something went wrong. Please contact Deasra Representative.", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
			})

		} catch(error) {
			setIsLoading(false);
            console.log(error)
            toast("Internal Server Error", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
		}
	  }

      const fetchServiceRequests = (instance, flag) => {
        getGridData(instance, flag);
    };

    const columnDefs = [
        {
            field: "sServiceDisplayName",
            headerName: "Resource",
            // width: 380,
            flex:1,
            cellStyle: { 'white-space': 'normal' },
            autoHeight: true,
          },
          {
            field: "sSRState",
            headerName: "Status",
            // width: 380,
            flex:1,
            cellStyle: { 'white-space': 'normal' },
            autoHeight: true,
          },
    ]

    const gridOptions = useMemo(() => ({
        suppressScrollOnNewData: true,
      }), []);

  return (
    <div className={`${isLoading && "set-opacity"}`}>
    {isLoading && <Spinner className="center-screen" />}
      <ESPSubscibersGrid
        data={data}
        onFetchServiceRequests={fetchServiceRequests}
        pages={pages}
        pageSize={pageSize}
        page={currentPage}
        pageSizeOptions={pageSizeOptions}
        selectedPageSizeOption={selectedPageSizeOption}
        onPageSizeOptionChange={(option) => {
            setSelectedPageSizeOption(option);
        }}
      resourceAvailedCountClick={resourceAvailedCountClick} oppourtunitiesAvailedCountClick={oppourtunitiesAvailedCountClick}/>

      <Modal isOpen={oppourtunitiesModal}>
                    <ModalContent className="medium-general-modal">
                        <div className="modal-header">
                            <span className="modal-title">Oppourtunities Availed</span>
                            <img
                                alt="close"
                                id="Close"
                                src={close_modal}
                                className="close modal-close"
                                onClick={openOppourtunitiesAvailedModalisFalse}
                            />
                        </div>

                        <div className="modal-body">
                            <div style={{
        height: "50vh",
      }}>
                                {/* <ReactTableFixedColumns
                                    minRows={0}
                                    data={oppAvailedData}
                                    columns={columns}
                                    style={{ overflowY: "initial", height: "400px" }}
                                    className="-striped hide-scrollbar overflowcss"
                                /> */}
                          <div style={{ height: "100%", boxSizing: "border-box" }}>
                              <div style={gridStyle} className="ag-theme-material">
                                  <AgGridReact ref={gridRef}
                                      rowData={oppAvailedData}
                                      columnDefs={columnDefs}
                                    //   pinnedBottomRowData={[footerRow]}
                                      gridOptions={gridOptions}
                                    //   overlayNoRowsTemplate={
                                    //       '<span class="ag-overlay-loading-center">loading...</span>'
                                    //   }
                                    //   rowClassRules={{
                                    //       'total-row': 'data.medium_name === "Total"'
                                    //   }}
                                  >
                                  </AgGridReact>
                              </div>
                          </div>
                            </div>
                        </div>
                    </ModalContent>
                </Modal>

                <Modal isOpen={resourceAvailedModal}>
                    <ModalContent className="medium-general-modal">
                        <div className="modal-header">
                            <span className="modal-title">Resources Availed</span>
                            <img
                                alt="close"
                                id="Close"
                                src={close_modal}
                                className="close modal-close"
                                onClick={openResourcesAvailedModalisFalse}
                            />
                        </div>

                        <div className="modal-body">
                            <div style={{
        height: "50vh",
      }}>
                          <div style={{ height: "100%", boxSizing: "border-box" }}>
                              <div style={gridStyle} className="ag-theme-material">
                                  <AgGridReact ref={gridRef}
                                      rowData={resourceAvailedData}
                                      columnDefs={columnDefs}
                                      gridOptions={gridOptions}
                                  >
                                  </AgGridReact>
                              </div>
                          </div>
                            </div>
                        </div>
                    </ModalContent>
                </Modal>
    </div>
  )
}

export default ESPSubscribersInterface
